import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-log-in',
    templateUrl: './log-in.component.html',
    styleUrls: ['./log-in.component.scss'],
    standalone: false
})
export class LogInComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
